import React, { useEffect, useState } from "react";
import { Bell, UserPlus, LogIn, Dot } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuLabel,
} from "./ui/dropdown-menu";

const ICONS = { agent_application: UserPlus, login: LogIn };

export default function NotificationBell() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = async () => {
    try { const { data } = await api.get("/notifications"); setItems(data.items || []); setUnread(data.unread || 0); }
    catch (_) {}
  };
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const onOpen = (o) => { if (!o && unread) markAll(); };

  const open = (n) => {
    if (n.type === "agent_application") navigate("/admin/agents");
  };

  return (
    <DropdownMenu onOpenChange={onOpen}>
      <DropdownMenuTrigger asChild>
        <button className="relative text-slate-500 hover:text-[#004030] p-2" data-testid="notification-bell" aria-label="Notifications">
          <Bell size={20} />
          {unread > 0 && <span className="absolute top-0.5 right-0.5 min-w-[16px] h-4 px-1 bg-red-500 text-white text-[10px] font-bold rounded-full grid place-items-center" data-testid="notification-unread">{unread > 9 ? "9+" : unread}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-[70vh] overflow-y-auto">
        <DropdownMenuLabel className="flex items-center justify-between">
          Notifications
          {unread > 0 && <button onClick={markAll} className="text-xs text-[#004030] font-medium hover:underline" data-testid="mark-all-read">Mark all read</button>}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.length === 0 && <div className="px-3 py-6 text-center text-sm text-slate-400">No notifications yet.</div>}
        {items.slice(0, 20).map((n) => {
          const Icon = ICONS[n.type] || Dot;
          return (
            <DropdownMenuItem key={n.id} onClick={() => open(n)} data-testid={`notif-${n.id}`} className={`flex items-start gap-2 ${!n.read ? "bg-[#f3f8f5]" : ""}`}>
              <Icon size={15} className="text-[#004030] mt-0.5 shrink-0" />
              <div className="min-w-0">
                <p className="text-sm font-medium text-[#012a1e] truncate">{n.title}</p>
                {n.body && <p className="text-xs text-slate-500 break-words">{n.body}</p>}
              </div>
            </DropdownMenuItem>
          );
        })}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/admin/activity")} data-testid="view-activity" className="justify-center text-[#004030] font-medium">View login activity</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
